import { Alert } from '@medely/ui-kit';
import React, { useEffect } from 'react';
import { StringParam, useQueryParams } from 'use-query-params';

export const HelpArticle = () => {
  const [{ url }] = useQueryParams({ url: StringParam });

  useEffect(() => {
    if (url) {
      window.location.replace(url);
    }
  }, [url]);

  return url ? null : (
    <Alert
      severity="error"
      variant="filled"
      title="Unable to open this link"
      description="Please try again."
      hideCloseIcon
    />
  );
};
